import { gql } from "@apollo/client";

export const GET_ORDERS = gql`
	query Orders($input: OrdersInput!) {
		orders(input: $input) {
			orders {
				id
				orderNumber
				clientName
				status
				archived
				employee1c
				managerUserId
				managerUser {
					id
					name
				}
				storage
				warehouse {
					id
					city
					name
				}
				driver {
					id
					name
					friendlyName
				}
				npCodes
				deliveryType
				deliveryAddress
				date
				createdAt
				orderHandleTacts {
					id
					orderId
					user {
						id
						role
						name
					}
					npCodes
					oldStatus
					newStatus
					comment
					createdAt
				}
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			totalCount
		}
	}
`;

export const NOVA_POSHTA_STATUSES = gql`
	query NovaPoshtaStatuses($input: NovaPoshtaStatusInput!) {
		novaPoshtaStatuses(input: $input) {
			code
			status
		}
	}
`;

export const CREATE_ORDER = gql`
	mutation CreateOrders($input: CreateOrderInput!) {
		createOrder(input: $input) {
			id
		}
	}
`;

export const UPDATE_ORDER = gql`
	mutation UpdateOrders($input: UpdateOrderInput!) {
		updateOrder(input: $input) {
			id
		}
	}
`;

export const DELETE_ORDER = gql`
	mutation DeleteOrder($id: String!) {
		deleteOrder(id: $id)
	}
`;

export const CONNECT_ORDERS_TO_MANAGER = gql`
	mutation ConnectOrdersToManager($managerUserId: String!) {
		connectOrdersToManager(managerUserId: $managerUserId)
	}
`;
